// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const IntegrationsIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "Integrations/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.492 1.667H6.508c-3.033 0-4.841 1.808-4.841 4.841v6.975c0 3.042 1.808 4.85 4.841 4.85h6.975c3.034 0 4.842-1.808 4.842-4.841V6.508c.008-3.033-1.8-4.841-4.833-4.841Zm-5.05 10.416a.629.629 0 0 1 0 .884.618.618 0 0 1-.442.183.618.618 0 0 1-.442-.183l-2.075-2.075a1.252 1.252 0 0 1 0-1.775l2.075-2.075a.629.629 0 0 1 .884 0 .629.629 0 0 1 0 .883L6.367 10l2.075 2.083Zm6.075-1.2-2.075 2.075a.618.618 0 0 1-.442.184.618.618 0 0 1-.442-.184.629.629 0 0 1 0-.883L13.633 10l-2.075-2.083a.629.629 0 0 1 0-.884.629.629 0 0 1 .884 0l2.075 2.075a1.252 1.252 0 0 1 0 1.775Z"
}));
export default IntegrationsIcon;